import React from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

interface GridWrapperProps {
  $standalone?: boolean;
}
const GridWrapper = styled.div<GridWrapperProps>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${({ theme, $standalone }) => {
    if ($standalone) {
      return css``;
    }
    return css`
      & > :nth-child(odd) {
        padding-right: ${theme.spacings.spacing24};
        border-right: 1px solid ${theme.colors.border2};
      }
      & > :nth-child(even) {
        padding-left: ${theme.spacings.spacing24};
      }
    `;
  }}
`;

interface Props {
  isStandalone?: boolean;
  children?: React.ReactNode;
}
const EnrollmentDetailsContributionsWrapper: React.FC<Props> = ({ children, isStandalone }) => {
  return (
    <Box
      pad="spacing24"
      background="canvas"
      round="container1Round"
      border={{ size: '1px', color: 'border2' }}
      gap="spacing16"
      direction="column"
    >
      <Box direction="row" align="center" height="28px">
        <Text size="xxlarge" weight={400}>
          Individual contributions status
        </Text>
      </Box>

      <GridWrapper $standalone={isStandalone}>{children}</GridWrapper>
    </Box>
  );
};

export default EnrollmentDetailsContributionsWrapper;
